import { createUseStyles } from "react-jss";
import { SPACING } from "../../../constants/styleGuide";

const EditRateModalStyles = createUseStyles({
	contentSpacing16: {
		paddingTop: SPACING.s16,
	},
	accordionDetailsGrid: {
		width: "100%",
		justifyContent: "space-between",
		marginLeft: 8,
		display: "flex",
	},
	editTextfield: {
		width: "80%"
	}
});

export default EditRateModalStyles;